import { useCarePlanContext } from "../care-plan";
import { CarePlanBranch, getStepDisplayName, isLinkedMessage } from "../types";
import { useState } from "react";
import Button from "@/components/ui/button";
import { Dialog, DialogBody, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
interface BranchSelectDialogProps {
  branch: CarePlanBranch;
  totalBranches: number;
  onConfirm: () => Promise<void>;
  children: React.ReactNode;
}
export function BranchSelectDialog({
  branch,
  totalBranches,
  onConfirm,
  children
}: BranchSelectDialogProps) {
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const {
    lookups: {
      serviceById,
      medicationById,
      measurementById
    }
  } = useCarePlanContext();
  const nonMessageSteps = branch.steps.filter(s => !isLinkedMessage(s));
  const skippedCount = totalBranches - 1;
  const handleConfirm = async () => {
    setIsLoading(true);
    try {
      await onConfirm();
      setIsOpen(false);
    } finally {
      setIsLoading(false);
    }
  };
  return <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>
            Select:{" "}
            <span>{branch.name || `Option ${branch.position + 1}`}</span>
          </DialogTitle>
          <DialogDescription>
            This will activate {nonMessageSteps.length} step
            <span>{nonMessageSteps.length !== 1 ? "s" : ""}</span> in this path
            and skip all steps in the other <span>{skippedCount}</span> option
            <span>{skippedCount !== 1 ? "s" : ""}</span>. This cannot be undone.
          </DialogDescription>
        </DialogHeader>

        <DialogBody>
          <div className="space-y-1">
            <p className="text-caption-strong text-foreground-secondary mb-2">
              Steps in this path:
            </p>
            {nonMessageSteps.map((step, i) => <p key={step.id} className="text-body text-foreground">
                <span className="text-foreground-muted mr-1.5">{i + 1}.</span>
                <span>
                  {getStepDisplayName(step, {
                serviceById,
                medicationById,
                measurementById
              }) || "Untitled Step"}
                </span>
              </p>)}
          </div>
        </DialogBody>

        <DialogFooter>
          <Button variant="secondary" onClick={() => setIsOpen(false)} disabled={isLoading}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleConfirm} isLoading={isLoading}>
            Confirm selection
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>;
}